import styled from 'styled-components';

export const Feedback = styled.div`
  border-radius: 5px;
  padding: 4px;
  background-color: #bd4932;
  color: white;
  display: flex;
  align-items: center;
  min-height: 50px;
`;